import { BaseButton } from "../../../../../../components/Button/BaseButton.tsx";
import { EmptyState } from "../../../../../../components/EmptyState/EmptyState.tsx";
import { BrandLogoItem } from "../../../../../components/BrandLogoItem.tsx";
import { useWorkspaceLogos } from "../../../../../hooks/useWorkspaceLogos.ts";
import { ImagePicker } from "../../../../components/ImagePicker.tsx";
import { IMAGE_LAYER_TYPE } from "../../Designer/constants.ts";
import { useCreateLayer } from "../../Designer/hooks/useCreateLayer.ts";

export const ImageEmptyState = () => {
  const createLayer = useCreateLayer();
  const workspaceLogos = useWorkspaceLogos();

  return (
    <EmptyState
      iconName="Image"
      title="Image"
      description="Upload an image or select from your brand."
      className="h-full w-full px-300"
    >
      <div className="w-full flex-col items-start gap-300">
        <ImagePicker
          onImageUuidChange={(uuid) =>
            createLayer({ layerType: IMAGE_LAYER_TYPE, contentUuid: uuid })
          }
          pipelineCompatible={false}
        />
        <div className="body-md-semibold">Brand images</div>
        {workspaceLogos.length > 0 ? (
          <div className="flex-row items-center gap-400 flex-wrap">
            {workspaceLogos.map((brand, index) => (
              <BaseButton
                key={index}
                className="hover:opacity-50"
                onClick={() => {
                  createLayer({
                    layerType: IMAGE_LAYER_TYPE,
                    contentUuid: brand.content_uuid,
                  });
                }}
              >
                <BrandLogoItem brand={brand} className="h-[100px]" />
              </BaseButton>
            ))}
          </div>
        ) : (
          "No brand logos found."
        )}
      </div>
    </EmptyState>
  );
};
